// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes animate-skeleton{0%{transform:translateX(-100%) translateY(-50%)}to{transform:translateX(100%) translateY(-50%)}}.search-router-link__in-box{position:relative}.search-router-link .search-router-link__lens-ico{position:absolute;left:-24px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
